// src/components/FooterSection.jsx
import React from 'react';
import { Box, Divider, Stack, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function FooterSection() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.privacy'), to: '/privacidad' },
    { label: t('footer.cookies'), to: '/cookies' },
    { label: t('footer.support', 'Soporte'), to: '/soporte' },
    { label: 'RuntriPhone', to: '/runtriphone' },
    { label: 'Canal Runtritón', to: '/canal' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 3, md: 8 },
        py: { xs: 5, md: 7 },
        background: 'linear-gradient(135deg, #101828 0%, #172033 48%, #E50914 150%)',
        color: '#fff',
      }}
    >
      <Stack spacing={3} alignItems="center" textAlign="center">
        <Box component="img" src="/runtriLogoCtt.PNG" alt="Runtritón Cartagena" sx={{ width: 108, filter: 'drop-shadow(0 14px 28px rgba(0,0,0,.26))' }} />

        <Box>
          <Typography variant="h4" sx={{ fontWeight: 900, lineHeight: 1 }}>
            C.D. Runtritón Cartagena
          </Typography>
          <Typography sx={{ mt: 1, color: 'rgba(255,255,255,0.72)', maxWidth: 620 }}>
            Comunidad, entrenos, carreras y vida de club desde Cartagena.
          </Typography>
        </Box>

        <Divider sx={{ width: 'min(760px, 100%)', borderColor: 'rgba(255,255,255,0.16)' }} />

        <Stack direction="row" spacing={1.5} justifyContent="center" flexWrap="wrap" useFlexGap>
          {footerLinks.map((item) => (
            <MuiLink
              key={item.to}
              component={Link}
              to={item.to}
              underline="none"
              sx={{
                color: 'rgba(255,255,255,0.78)',
                fontWeight: 800,
                px: 1.5,
                py: 0.85,
                borderRadius: 999,
                '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.10)' },
              }}
            >
              {item.label}
            </MuiLink>
          ))}
        </Stack>

        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.54)', fontWeight: 800, letterSpacing: '0.08em' }}>
          RUNTRITON CARTAGENA 2026 · Produced by @gus
        </Typography>
      </Stack>
    </Box>
  );
}

export default FooterSection;
